var colorUtil = require("./colors");
var a11y = require("./a11y");

function PDFHr(color, height) {
    if (typeof color === "number") {
        height = color;
        color = "black";
    }
    this.color = color || "black";
    this.height = typeof color === "number" ? color : height || 0;

    // TODO: validate the inputs
}
PDFHr.prototype.calc = function(cursor) {
    return {
        width: cursor.width,
        height: this.height === 0 ? 1 : this.height
    };
};
PDFHr.prototype.draw = function(cursor) {
    return a11y.artifact(
        cursor,
        function() {
            cursor.doc.setFillColor.apply(cursor.doc, colorUtil.getRGB(this.color));
            cursor.doc.rect(cursor.x, cursor.y, cursor.width, this.height, "F");

            return this.calc(cursor);
        },
        this
    );
};

module.exports = PDFHr;
